module.exports = __webpack_public_path__ + "img/back_20.d99b9e10.svg";